export default {
  login: {
    title: '로그인',
    usernameLabel: '사용자 이름',
    usernamePlaceholder: '영어로 시작하는 2-10개의 영어 숫자 조합',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '로그인 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    hasNoAccount: '아직 계정이 없습니다.',
    goRegister: '등록으로 이동',
    onlineCustom: '온라인 고객 서비스',
    loginArgument: '계속 로그인하면 동의한 것으로 간주됩니다.',
    userArgument: '"사용자 계약"',
    RegisterNotEnabled: '등록 기능이 열려 있지 않습니다. 관리자에게 문의하세요.',
    usernameRequired: '올바른 사용자 이름을 입력하세요',
    loginPasswordRequired: '올바른 로그인 비밀번호를 입력하세요',
    googleCodeRequired: '올바른 Google 인증 코드를 입력하세요',
    loginButton: '로그인'
  },
  register: {
    title: '등록',
    usernameLabel: '사용자 이름',
    usernamePlaceholder: '등록된 사용자 이름을 입력하세요',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '등록된 사용자의 로그인 비밀번호를 입력하세요',
    loginPasswordPreLabel: '로그인 비밀번호 확인',
    loginPasswordPrePlaceholder: '로그인 비밀번호를 다시 입력하세요',
    fudPasswordLabel: '펀드 비밀번호',
    fudPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    inviteCodeLabel: '초대 코드',
    inviteCodePlaceholder: '초대코드 6자리를 입력하세요',
    registerNeed: '계속 등록하는 것은 동의를 나타냅니다.',
    registerArgument: '"등록 계약"',
    usernameRequired: '올바른 사용자 이름을 입력하세요',
    loginPasswordRequired: '올바른 로그인 비밀번호를 입력하세요',
    loginPasswordPreRequired: '올바른 확인 로그인 비밀번호를 입력하세요',
    fundPasswordRequired: '올바른 펀드 비밀번호를 입력하세요',
    inviteCodeRequired: '올바른 초대 코드를 입력하세요',
    diffLoginPasswordError: '입력한 두 개의 로그인 비밀번호가 일치하지 않습니다.',
    registerSuccess: '등록 성공',
    registerButton: '등록',
    emailLabel: '이메일',
    emailPlaceholder: '이메일 주소를 입력하세요',
    emailCodeLabel: '인증 코드',
    emailCodePlaceholder: '이메일 확인 코드를 입력하세요',
    second: '두 번째',
    getEmailCodeButton: '인증 코드 받기',
    emailRequired: '올바른 이메일 주소를 입력하고 다시 시도하세요',
    emailCodeRequired: '올바른 이메일 확인 코드를 입력하고 다시 시도하십시오'
  },
  home: {
    hotCoin: {
      title: '핫 딜',
      more: '더'
    },
    poster: {
      title: '빠른 입금',
      enter: '지금 입력하세요>',
      subTitle: 'BTC, USDT, ETH 등 지원'
    },
    quickMenus: {
      futuresTrading: '선물 거래',
      helpCenter: '도움말 센터'
    },
    ranking: {
      increase: {
        title: '성장 목록'
      },
      clinch: {
        title: '거래량 목록'
      }
    }
  },
  tabBar: {
    home: '집',
    price: '견적',
    trade: '무역',
    fund: '자산',
    user: '내'
  },
  currency: {
    favorite: '당신의 선택',
    allCurrency: '현물',
    dayVol: '24시간 금액',
    addFavor: '+ 다음에 추가'
  },
  trade: {
    bills: '주문',
    todayOpen: '열기',
    star: '당신의 선택',
    vol: '거래량',
    low: '가장 낮음',
    high: '가장 높음',
    timing: '매우 빠르다',
    spot: '선물',
    buyMore: '추가 구매',
    buyEmpty: '단기 구매',
    indicator: '표시기',
    indicatorSettings: '표시기 설정',
    balance: '내 잔액',
    fee: '서비스 수수료',
    ruleIdError: '만료 시간을 선택하세요',
    deleteFavoriteSuccess: 'FavoriteSuccess 삭제',
    addFavoriteSuccess: '선택한 통화를 성공적으로 추가했습니다.',
    buyIn: '구매',
    sellOut: '판매',
    holding: '위치',
    history: '역사',
    spotOrderConfirm: {
      title: '구매 확인',
      amountPlaceholder: '구매 수량을 입력하세요'
    },
    spotTradeOrder: {
      holding: {
        coin: '통화',
        buyInAmountPrice: '총 구매 가격/단가',
        buyInCount: '수량',
        actions: '작업',
        sellOut: '판매',
        profit: '이익과 손실'
      }
    },
    orderConfirm: {
      title: '주문 확인',
      coinName: '통화',
      direction: '방향',
      price: '현재 가격',
      balance: '균형',
      fee: '서비스 수수료',
      buyMoreLabel: '추가 구매',
      buyEmptyLabel: '짧게 구매하세요',
      buyQuantity: '구매 수량',
      buyAmount: '구매 금액',
      submit: '주문 확인'
    },
    kline: {
      open: '열다:',
      close: '닫기:',
      change: '위 또는 아래:'
    }
  },
  finance: {
    title: '금융'
  },
  allFinance: {
    title: '재무관리',
    all: '모두'
  },
  financeOrders: {
    title: '서약 명령',
    holdingLabel: '보유',
    historyLabel: '역사',
    holding: {
      amount: '약정 금액',
      rateStr: '소득 금액/수익률',
      vcCount: '담보 코인 수량',
      cycle: '위치주기',
      day: '일',
      calcStartDate: '값 날짜',
      serviceAmount: '서비스 수수료',
      redeemOrder: '상환'
    },
    history: {
      incomeAmount: '소득 금액',
      rateStr: '수율',
      amount: '약정 금액',
      vcCount: '담보 코인 수량',
      calcStartDate: '값 날짜',
      calcEndDate: '이자 종료 날짜',
      cycle: '주기일',
      serviceAmount: '서비스 수수료',
      day: '일'
    }
  },
  financeOrderBills: {
    title: '공약소득 청구서',
    amount: '금액',
    balance: '균형'
  },
  financeItem: {
    rateStr: '수율',
    buyType: '구매 유형',
    cycle: '주기일',
    exchangeRate: '환율(가상화폐 교환 잔액)',
    day: '일',
    cycleType: '주기 유형',
    serviceRateStr: '서비스 요금'
  },
  buyFinance: {
    title: '구매',
    rateStr: '수율',
    name: '이름',
    buyType: '구매 유형',
    cycle: '주기일',
    cycleType: '주기 유형',
    exchangeRate: '환율(가상화폐 교환 잔액)',
    serviceRateStr: '서비스 요금',
    remark: '비고',
    buyAmountLabel: '구매 금액 ({coin})',
    descriptionTitle: '제품 설명',
    descriptionPart1: '1. 본 상품은 무원금 보장 금융상품입니다. 시세 변동에 따라 원금 손실이 발생할 수 있으니 신중하게 투자하시기 바랍니다.',
    descriptionPart2: '2. 지불 정산 규칙:',
    descriptionPart3: '정산가격 < 연동가격인 경우, BTC는 만기 이후 정산되며, 정산금액 = 투자금액* (1 + 일수 * 연환산수익률 / 365).',
    descriptionPart4: '결제 가격 ≥ 연결 가격인 경우 USDT는 만료 후 정산됩니다. 결제 수량 = 투자 금액 * 연결 가격 * (1 + 일수 * 연간 수익률 / 365).',
    descriptionPart5: '3. 실제 연간 수익률은 시장 상황에 따라 실시간으로 변경됩니다. 실제 구매 거래를 참고하세요.',
    descriptionPart6: '4. 투자금액은 시세에 따라 실시간으로 환산되므로 실제 구매거래를 참고하시기 바랍니다.',
    descriptionPart7: '5. 상품 구매 후 내 화폐 보유 페이지에서 확인하실 수 있습니다. 만료 후 자동으로 현물 계좌로 환불됩니다.',
    buyButton: '[{코인}] 구매'
  },
  fund: {
    description: '자산',
    recharge: '재충전',
    withdraw: '통화 철회',
    exchange: '이전',
    empty: '지갑이 비어 있습니다. 가세요'
  },
  userCenter: {
    lastLogin: '마지막 로그인',
    myTeam: '내 팀',
    identity: '실명인증',
    walletAddress: '지갑 주소',
    zskAccount: 'FPS 계정',
    bankCard: '은행 계좌',
    userBills: '계정 변경 기록',
    timingTradeOrder: '매우 빠른 포지션',
    spotTradeOrder: '선물 포지션',
    contactTradeOrder: '계약 위치',
    userReport: '사용자 보고서',
    teamReport: '팀 보고서',
    share: '공유하고 싶습니다',
    customer: '고객 서비스에 문의하세요',
    helpCenter: '도움말 센터',
    platform: '플랫폼 소개',
    profit: '오늘의 손익',
    balance: '내 잔액',
    withdraw: '통화 철회',
    recharge: '재충전',
    creditStoreLabel: '신용 포인트'
  },
  settings: {
    title: '설정',
    fundPassword: '펀드 비밀번호',
    googleValidator: 'Google 유효성 검사기',
    editLoginPassword: '로그인 비밀번호 변경',
    switchLocale: '언어 전환'
  },
  editFundPassword: {
    title: '펀드 비밀번호 변경',
    currentPasswordLabel: '현재 비밀번호',
    currentPasswordPlaceholder: '현재 펀드 비밀번호를 입력하세요',
    newPasswordLabel: '새 비밀번호',
    newPasswordPlaceholder: '수정된 펀드 비밀번호를 입력하세요',
    prePasswordLabel: '비밀번호 확인',
    prePasswordPlaceholder: '수정된 펀드 비밀번호를 다시 입력하세요',
    tips: '펀드 비밀번호는 거래에 있어 중요한 인증서이므로 잘 설정하시고 기억해두시기 바랍니다',
    currentPasswordRequired: '현재 펀드 비밀번호를 입력하세요',
    newPasswordRequired: '수정할 펀드 비밀번호를 입력하세요',
    prePasswordRequired: '다시 수정하려면 펀드 비밀번호를 입력하세요',
    prePasswordDiff: '두 개의 비밀번호 항목이 일치하지 않습니다'
  },
  bindFundPassword: {
    title: '바인딩 펀드 비밀번호',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    fundPasswordPreLabel: '비밀번호 확인',
    fundPasswordPrePlaceholder: '펀드 비밀번호를 다시 입력하세요',
    fundPasswordRequired: '올바른 펀드 비밀번호를 입력하세요',
    fundPasswordPreRequired: '올바른 확인 비밀번호를 입력하세요',
    fundPasswordDiff: '두 개의 비밀번호 항목이 일치하지 않습니다',
    binSuccess: '자금 비밀번호 바인딩 성공',
    tips: '펀드 비밀번호는 거래에 있어 중요한 인증서이므로 신중하게 설정하고 기억하시기 바랍니다'
  },
  editLoginPassword: {
    title: '로그인 비밀번호 변경',
    currentPasswordLabel: '현재 비밀번호',
    currentPasswordPlaceholder: '현재 로그인 비밀번호를 입력하세요',
    newPasswordLabel: '새 비밀번호',
    newPasswordPlaceholder: '수정된 로그인 비밀번호를 입력하세요',
    prePasswordLabel: '비밀번호 확인',
    prePasswordPlaceholder: '수정된 로그인 비밀번호를 다시 입력하세요',
    tips: '로그인 비밀번호는 로그인 인증 등에 있어 중요한 정보이므로 잘 설정하시고 기억해두시기 바랍니다',
    currentPasswordRequired: '현재 로그인 비밀번호를 입력하세요',
    newPasswordRequired: '수정할 로그인 비밀번호를 입력하세요',
    prePasswordRequired: '다시 수정하려면 로그인 비밀번호를 입력하세요',
    prePasswordDiff: '두 개의 비밀번호 입력이 일치하지 않습니다'
  },
  bindGoogleValidator: {
    title: 'Google OTP 바인딩',
    qrCodeLabel: 'QR 코드',
    keyLabel: '키',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '로그인 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    tipsPart1: 'App Store에서 Google OTP 검색',
    tipsPart2: 'Google OTP를 사용하여 위의 QR 코드를 스캔하거나 수동으로 키를 입력하여 바인딩하세요',
    tipsPart3: '위의 6자리 Google 인증 코드를 입력하고 확인 및 제출을 클릭하세요',
    loginPasswordRequired: '로그인 비밀번호를 입력하세요',
    googleCodeRequired: '6자리 Google 인증 코드를 입력하세요.'
  },
  walletAddress: {
    title: '지갑 주소',
    add: '+ 지갑 주소 추가',
    remark: '비고',
    addButton: '지갑 주소 추가',
    tips: '주소 정보 수정, 삭제를 원하실 경우 고객센터로 연락주세요'
  },
  addWalletAddress: {
    title: '지갑 주소 추가',
    vcChainNameIdLabel: '체인 유형',
    vcAccountLabel: '지갑 주소',
    vcAccountPlaceholder: '지갑 주소를 입력하세요',
    remarkLabel: '비고',
    remarkPlaceholder: '비고 내용을 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '추가된 지갑 주소는 수정할 수 없습니다. 정보가 올바른지 확인하세요.',
    vcIdRequired: '올바른 통화를 선택하세요',
    vcChainNameIdRequired: '올바른 체인 유형을 선택하세요',
    vcAccountRequired: '올바른 지갑 주소를 입력하세요',
    fundPwdRequired: '올바른 펀드 비밀번호를 입력하세요',
    addSuccess: '지갑 주소가 성공적으로 추가되었습니다.'
  },
  receiveWays: {
    title: '내 은행 카드',
    add: '+ 은행 카드 추가',
    tips: '은행 카드 정보를 수정하거나 삭제하려면 고객 서비스에 문의하세요',
    addCardButton: '은행 카드 추가'
  },
  zskAccount: {
    title: 'FPS 계정',
    add: '+ FPS 계정 추가',
    tips: '계정정보 수정, 삭제를 원하시면 고객센터로 연락주세요',
    addCardButton: '계정 추가'
  },
  addZskAccount: {
    title: '새 FPS 계정',
    withdrawNameLabel: '이름',
    withdrawNamePlaceholder: '이름을 입력하세요',
    withdrawNameRequired: '이름은 비워둘 수 없습니다.',
    zskLabel: 'FPS',
    zskPlaceholder: 'FPS를 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '계좌 추가 정보 입력 시 주의하시기 바랍니다. 잘못된 정보 입력으로 인한 출금 실패에 대해 회사는 책임을 지지 않습니다.'
  },
  addBankCard: {
    title: '새 은행 카드 추가',
    cardNumLabel: '은행 카드 번호',
    withdrawNameLabel: '이름',
    withdrawNamePlaceholder: '이름을 입력하세요',
    withdrawNameRequired: '이름은 비워둘 수 없습니다.',
    zskLabel: 'FPS',
    zskPlaceholder: 'FPS를 입력하세요',
    zskRequired: '올바른 FPS를 입력하세요',
    cardNumPlaceholder: '은행 카드 번호를 입력하세요',
    branchLabel: '지점 주소',
    branchPlaceholder: '은행 카드 지점 주소를 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '은행카드\'는 거래 및 현금출금에 있어 중요한 정보이므로 꼭 기재해 주시기 바랍니다. 카드정보를 잘못 기재하여 출금이 되지 않는 등의 문제에 대해서는 회사에서는 책임을 지지 않습니다. ',
    backIdRequired: '계좌 개설 은행을 선택하세요',
    cardNumRequired: '올바른 은행 카드 번호를 입력하세요',
    fundPwdRequired: '올바른 펀드 비밀번호를 입력하세요',
    idCardPlaceholder: 'ID 번호를 입력하세요',
    idCardLabel: '신분증 번호',
    idCardRequired: '올바른 ID 번호를 입력하세요',
    cciPlaceholder: '은행 카드 CCI를 입력하세요',
    branchCodePlaceholder: '지점 번호를 입력하세요',
    branchCodeLabel: '지점 번호',
    katakanaPlaceholder: '가타카나를 입력하세요',
    katakanaLabel: '가타카나'
  },
  userBills: {
    title: '계정 변경 기록',
    vcName: '통화',
    amount: '금액',
    balance: '균형'
  },
  timingTradeOrder: {
    title: '매우 빠른 거래 주문',
    waiting: {
      title: '진행 중인 주문',
      amount: '금액',
      period: '기간',
      receivePrice: '구매 가격',
      settlement: '정착'
    },
    history: {
      title: '역사적 명령',
      buyInClose: '매수 가격',
      saleOutClose: '판매 가격'
    }
  },
  spotTradeOrder: {
    title: '선물 거래 주문',
    waiting: {
      title: '진행 중인 주문',
      buyInAmount: '총 구매 가격',
      buyInPrice: '구매 단가',
      buyInCount: '구매 수량',
      buyInTime: '구매 시간'
    },
    history: {
      title: '역사적 명령',
      buyInAmount: '총 구매 가격',
      buyInPrice: '구매 단가',
      buyInCount: '구매 수량',
      sellOutAmount: '총 판매가',
      sellOutPrice: '판매 단가',
      sellOutTime: '판매 시간'
    }
  },
  userReport: {
    title: '이용자 신고',
    profit: '이익',
    timingTradeAmountFee: '매우 빠른 거래 주문/처리 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/취급 수수료',
    withdrawInfo: '인출/취급 수수료',
    exchangeInfo: '교환/취급 수수료'
  },
  userReportDay: {
    title: '사용자 일일 보고서',
    profit: '이익',
    timingTradeAmountFee: '매우 빠른 거래 주문/처리 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/취급 수수료',
    withdrawInfo: '인출/취급 수수료',
    exchangeInfo: '교환/취급 수수료'
  },
  teamReport: {
    title: '팀 보고서',
    goToReportDay: '일별 보고서 보기',
    timingTradeBetAmountServiceCharge: '매우 빠른 거래 주문/서비스 수수료',
    timingTradeBetPrizePoint: '매우 빠른 거래 보너스/리베이트',
    timingTradeUserAndCount: '고속 거래 수/거래 수',
    rechargeAmountFee: '충전금액/서비스 수수료',
    rechargePersonCount: '충전 횟수/거래 횟수',
    withdrawAmountFee: '출금 금액/서비스 수수료',
    withdrawPersonCount: '코인을 인출하는 사람 수/거래 수',
    firstRechargeUserAndCount: '첫 번째 충전 금액/인원',
    usernamePlaceholder: '하위 사용자 이름을 입력하세요',
    previewAllTradeInfo: '모든 고속 거래 정보 보기',
    coin: '통화',
    timingTradeBetAmount: '스피드 트레이딩 베팅 금액',
    profit: '이익',
    action: '액션',
    previewReportDay: '일별 보고서 보기'
  },
  teamTimingTradeInfo: {
    title: '팀 빠른 거래',
    profit: '이익',
    subTitle: '팀 스피드 트레이딩 정보',
    timingTradeAmountFee: '매우 빠른 거래 주문/서비스 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/서비스 수수료',
    withdrawInfo: '출금/서비스 수수료',
    exchangeInfo: '교환/서비스 수수료'
  },
  teamReportDay: {
    title: '팀 일일 보고서',
    subTitle: '팀 [ {username} ] 일일 보고서',
    timingTradeBetAmountFee: '매우 빠른 거래 주문/서비스 수수료',
    timingTradeBetPrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeAmountFee: '충전금액/서비스 수수료',
    rechargePersonCount: '충전 횟수/거래 횟수',
    timingTradeUserAndCount: '고속 거래 수/거래 수',
    firstRechargePersonCount: '첫 번째 충전 금액/거래 횟수',
    withdrawAmountFee: '출금 금액/서비스 수수료',
    withdrawPersonCount: '코인을 인출하는 사람 수/거래 수',
    exchangeAmountFee: '교환 금액/서비스 수수료'
  },
  share: {
    title: '공유하고 싶어요',
    qrCodeLabel: 'QR 코드',
    RegisterUrlLabel: '등록 주소',
    inviteCodeLabel: '초대 코드',
    hasNoInviteCode: '현재 계정에는 초대 코드가 없습니다.',
    generateInvitationCode: '원클릭 생성을 시도해보세요',
    tipsPart1: '위 QR 코드를 스캔하고 등록 정보를 입력하여 등록하세요',
    tipsPart2: '등록 주소를 복사하고 등록 정보를 입력하여 등록하세요',
    tipsPart3: '이 사이트의 등록 인터페이스를 수동으로 열고 등록하려면 초대 코드를 입력하세요',
    saveImageError: '이미지를 저장하지 못했습니다. 이미지를 길게 누른 후 저장해 보세요.'
  },

  myTeam: {
    title: '내 팀',
    usernamePlaceholder: '하위 사용자 이름을 입력하세요',
    point: '리베이트(속도/계약)',
    totalBalance: '균형',
    lastLoginTime: '마지막 로그인 시간',
    noLoginTime: '없음'
  },
  userDetail: {
    username: '사용자 이름',
    userType: '사용자 유형',
    title: '사용자 세부정보',
    pointPercentTiming: '매우 빠른 거래 리베이트',
    pointPercentContract: '계약 거래 리베이트',
    registerWay: '등록 방법',
    teamCounts: '팀 번호',
    teamOnline: '팀 온라인',
    balance: '균형',
    registerTime: '등록 시간',
    onlineStatus: '로그인 상태'
  },
  addUser: {
    title: '신규 사용자',
    addUserDirect: {
      userTypeLabel: '사용자 유형',
      usernameLabel: '사용자 이름',
      usernamePlaceholder: '계좌 개설 사용자 이름을 입력하세요',
      pointTimingLabel: '매우 빠른 거래 리베이트',
      pointContractLabel: '계약 거래 리베이트',
      tips: '초기 비밀번호는 "{password}"입니다. 계정을 개설한 후 제때에 비밀번호를 변경하도록 사용자에게 상기시켜주세요.',
      userTypeRequired: '계좌 개설 유형을 선택하세요',
      usernameRequired: '계좌 개설 사용자 이름을 입력하세요',
      pointTimingRequired: '빠른 거래 리베이트를 선택하세요',
      pointContractRequired: '계약 거래 리베이트를 선택하세요',
      copyTemplate: `
         사용자 이름: {사용자 이름};
         로그인 비밀번호: {loginPassword};
         로그인 URL: {loginAddress};
         매우 빠른 거래 리베이트: {timingTradePoint};
         계약 거래 리베이트: {contactTradePoint};
         `
    }
  },
  recharge: {
    title: '입금',
    configIdLabel: '입금 채널',
    chainNameLabel: '체인 이름',
    amountLabel: '충전 금액',
    userCardNameLabel: '지급인',
    userCardNamePlaceholder: '지급인 이름을 입력하세요',
    fee: '서비스 수수료',
    receiveAmountTipsPart1: '충전',
    receiveAmountTipsPart2: ', 결제 필요',
    tipsPart1: '온라인 결제 인터페이스가 불안정하기 때문에 현재 오프라인 전송 및 충전만 지원합니다! ',
    tipsPart2: '실제 이체 금액을 사실대로 입력해 주세요. 그렇지 않으면 시스템 검토에 실패하여 충전 진행에 영향을 미칠 수 있습니다. ',
    emptyPart1: '사용 가능한 충전 채널이 없습니다, ',
    emptyPart2: '다시 시도하려면 터치하세요',
    amountRequired: '충전 금액은 비워둘 수 없습니다',
    maxPrecisionError: '충전 금액은 소수점 이하 {amountMaxPrecision}자리까지 가능합니다.',
    payUserNameError: '올바른 지불인을 입력하고 다시 시도하세요',
    userMobileLabel: '휴대폰번호',
    userMobilePlaceholder: '사용자의 휴대폰 번호를 입력하세요',
    needPayLabel: '결제해야 함',
    needPayPlaceholder: '금액을 입력하려면 클릭하세요'
  },
  payDetail: {
    title: '이전 정보',
    addressLabel: '입금 주소',
    rechargeAmount: '충전 금액',
    bankNameLabel: '은행',
    branchLabel: '지점 주소',
    cardName: '이름',
    cardNum: '카드 번호',
    uploadImgLabel: '결제 바우처',
    uploadImgPlaceholder: '결제 바우처 이미지를 업로드하려면 클릭하세요',
    uploadImgRequired: '결제 바우처 이미지를 업로드해주세요',
    vcTransferTipsPart1: '1. 입금하려면 입금 주소를 복사하거나 QR 코드를 스캔하세요.',
    vcTransferTipsPart2: '2. 입금 완료 후 결제 바우처 이미지 업로드',
    vcTransferTipsPart3: '입금 효율성을 높이기 위해 선명한 고화질 바우처 사진을 업로드하시기 바랍니다. 관련 정보 사진이 선명하지 않은 경우 시스템 감사가 실패하여 충전 진행에 영향을 미칠 수 있습니다. ',
    bankCardTips: '충전 효율성을 높이기 위해 입력하는 송금인과 송금인의 이름이 일치하는지 확인하세요. 관련 정보가 일치하지 않으면 시스템 검토를 통과하지 못하고 충전 진행에 영향을 미칠 수 있습니다. ',
    bankCardTransferSuccess: '성공적으로 이체했습니다'
  },
  rechargeOrder: {
    title: '입금주문',
    payAmount: '충전 금액',
    receiveAmount: '받은 금액'
  },
  identity: {
    title: '실명정보',
    subTitle: '실명인증에는 정보인증과 본인인증이 포함됩니다',
    name: '이름',
    idType: '문서 유형',
    idNum: 'ID 번호',
    demand: '수요',
    informationVer: '정보 확인',
    idAuthentication: '신원 인증',
    material: '재료'
  },

  verified: {
    title: '실명인증',
    idCardTypeLabel: '인증서 유형',
    idCardFrontSideImgLabel: '신분증 사진 앞면',
    idCardBackSideImgLabel: '증명사진 뒷면',
    idCardHandSideImgLabel: '휴대용 신분증 사진',
    nameLabel: '문서 이름',
    namePlaceholder: 'ID 이름을 입력하세요',
    idCardNumLabel: '인증서 번호',
    idCardNumPlaceholder: 'ID 번호를 입력하세요',
    fundPwdLabel: '펀드 비밀번호',
    fundPwdPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '인증정보를 한번 제출하면 수정이 불가능하니 꼭 확인하시고 정확하게 입력해주세요',
    idCardTypeRequired: '인증서 유형을 선택하세요',
    idCardFrontSideImgRequired: '신분증 앞면 사진을 업로드해 주세요.',
    idCardBackSideImgRequired: '신분증 뒷면 사진을 업로드해주세요',
    idCardHandSideImgRequired: '신분증 사진을 업로드해주세요',
    nameRequired: '인증서 이름을 입력하세요',
    idCardNumRequired: 'ID 번호를 입력하세요',
    fundPwdRequired: '펀드 비밀번호를 입력하세요',
    submitSuccess: '인증 요청이 성공적으로 제출되었습니다'
  },
  help: {
    title: '도움말 센터'
  },
  helpDetail: {
    title: '도움말 세부정보'
  },
  myMessage: {
    title: '내 비공개 메시지'
  },
  messageDetail: {
    title: '비공개 메시지 세부정보'
  },
  withdraw: {
    title: '코인 출금',
    tips: '자금의 안전과 출금의 효율성을 보장하기 위해, 입력된 정보가 정확한지 주의 깊게 확인하시기 바랍니다. 출금 과정에서 발생하는 처리 수수료는 잔액에서 차감됩니다.',
    receiveAmountTipsPart1: '철회',
    receiveAmountTipsPart2: ', 예상 도착 시간',
    fee: '서비스 수수료',
    myBalance: '내 [ {vcName} ] 잔액:',
    configIdLabel: '출금 채널',
    amountLabel: '출금 금액',
    fundLabel: '펀드 비밀번호',
    fundPlaceholder: '펀드 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    maxPrecisionError: '출금 금액은 소수점 이하 {amountMaxPrecision}자리까지 가능합니다.',
    amountRequired: '올바른 인출 금액을 입력하거나 선택하세요',
    bankCardError: '올바른 은행 카드를 선택하세요',
    fundPwdError: '올바른 펀드 비밀번호를 입력하세요',
    walletAddressError: '올바른 지갑 주소를 선택하세요',
    success: '출금 요청이 성공적으로 제출되었습니다. 처리를 기다려주세요',
    emptyPart1: '사용 가능한 통화 인출 채널이 없습니다, ',
    emptyPart2: '다시 시도하려면 터치하세요.'
  },
  withdrawOrder: {
    title: '철회 명령',
    requestAmount: '선하증권 금액',
    receiveAmount: '받은 금액'
  },
  locales: {
    title: '언어 전환'
  },
  lines: {
    title: '라인 선택',
    switchLine: '스위치 라인'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'FavoriteSuccess 삭제',
    addFavoriteSuccess: '선택한 통화를 성공적으로 추가했습니다.'
  },
  currencySelect: {
    currencyName: '통화',
    currencyPlaceholder: '통화를 선택하려면 클릭하세요.'
  },
  walletItem: {
    available: '사용 가능',
    convert: '변환됨(USDT)'
  },
  banks: {
    bankIdLabel: '은행',
    bankIdPlaceholder: '은행을 선택하려면 클릭하세요.'
  },
  banksPop: {
    title: '은행 선택',
    search: '은행 키워드 입력'
  },

  historyOrderDetail: {
    title: '주문 세부정보',
    coin: '거래 통화',
    amount: '주문 금액',
    buyInClose: '매수 가격',
    sellOutClose: '판매 가격',
    isQuest: '이 주문에 대해 질문이 있나요?',
    connectCustomer: '고객 서비스에 문의하시겠습니까?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '사용자 리베이트를 선택하려면 클릭하세요.'
  },
  walletAddressSelect: {
    title: '지갑 주소 선택',
    label: '지갑 주소',
    placeholder: '지갑 주소를 선택하려면 클릭하세요'
  },
  myCardSelect: {
    title: '계정 선택',
    label: '수수료 계좌',
    placeholder: '계정을 선택하려면 클릭하세요.'
  },
  amountInput: {
    amountRange: '최소 {minAmount}, 최대 {maxAmount}',
    amountMin: '최소 {minAmount}, 상한 없음',
    amountErrorEmpty: '{label}이(가) 잘못되었습니다. 확인하고 다시 시도하세요',
    amountErrorOutRange: '{label}이(가) 범위를 벗어났습니다. 확인하고 다시 시도해 주세요.'
  },
  amountFormItem: {
    placeholderOnlyMin: '최소 {minAmount}, 상한 없음',
    placeholderHasMax: '최소 {minAmount}, 최대 {maxAmount}',
    amountErrorEmpty: '금액이 잘못되었습니다. 확인 후 다시 시도해 주세요.',
    amountErrorOutRange: '금액이 범위를 벗어났습니다. 확인하고 다시 시도하십시오.'
  },
  common: {
    remark: '비고',
    saveImage: '로컬 저장',
    online: '온라인',
    offline: '오프라인',
    profit: '이익과 손실',
    date: '날짜',
    period: '기간',
    pointAmount: '사용자 리베이트 금액',
    point: '사용자 리베이트',
    direction: '방향',
    winLoss: '이익',
    lose: '잃다',
    add: '더하다',
    win: '승리',
    edit: '수정',
    notBind: '바인딩되지 않음',
    alreadyBind: '이미 바인딩됨',
    enabled: '활성화됨',
    notEnabled: '활성화되지 않음',
    queryRange: '쿼리 범위',
    copy: '복사',
    orderNum: '주문 번호',
    null: '없음',
    noData: '아직 데이터가 없습니다',
    refreshSuccess: '새로 고침 성공',
    loadMoreData: '추가 데이터 로드',
    noMoreData: '더 이상 데이터가 없습니다',
    lookMore: '더 보기',
    more: '더'
  },
  date: {
    today: '오늘',
    yesterday: '어제',
    last7Days: '지난 7일',
    last14Days: '지난 14일',
    split: '에'
  },
  button: {
    save: '저장',
    logout: '로그아웃',
    confirm: '알았어',
    cancel: '취소',
    submit: '제출',
    addNow: '지금 추가',
    reset: '재설정',
    nextStep: '다음 단계',
    goCertification: '인증으로 이동'
  },
  confirm: {
    title: {
      logout: '로그아웃',
      unBindFundPassword: '언바운드 펀드 비밀번호',
      addUserDirect: '사용자 추가',
      addUserInfo: '사용자를 성공적으로 추가했습니다',
      jumpToRechargePage: '점프 확인',
      unAuthentication: '실명인증이 아닙니다.',
      noBindBankCard: '은행 카드가 추가되지 않았습니다',
      noBindCoinAddress: '지갑 주소가 추가되지 않았습니다',
      tradeConfirm: '거래 확인',
      sellOutSpotOrder: '포지션 매도',
      buyFinance: '구매 확인',
      receiveOrder: '주문 상환 약속'
    },
    content: {
      logout: '현재 계정에서 로그아웃하시겠습니까?',
      unBindFundPassword: '언바운드 펀드 비밀번호가 감지되었습니다. 계정 보안을 보장하려면 먼저 펀드 비밀번호를 바인딩하십시오.',
      addUserDirect: '새 사용자가 추가되려고 합니다. 정보가 올바른지 확인한 후 계속하려면 확인을 클릭하세요. 사용자 이름 [ {username} ], 사용자 유형 [ {userType} ], 로그인 비밀번호 [ {password} ], 내 속도 거래 리베이트 간의 차이 [ {diffPointTiming} ], 내 계약 거래 간의 리베이트 차이 [ {diffPointContract} ]',
      addUserInfo: '사용자 이름 [ {username} ]; <br /> 로그인 비밀번호 [ {password} ]; <br /> 로그인 URL [ {loginAddress} ]; <br /> 빠른 거래 리베이트 [ {pointPercentTiming} ]; <br / > />계약 거래 리베이트 [{pointPercentContract}];',
      jumpToRechargePage: '3자 충전 인터페이스가 곧 점프할 예정입니다. 계속하려면 확인을 클릭하세요.',
      unAuthentication: '계좌가 실명인증을 거치지 않은 것으로 감지되었습니다. 원활한 자금유통을 위해 실명인증을 먼저 진행해 주시기 바랍니다.',
      noBindBankCard: '계좌에 은행 카드가 연결되어 있지 않거나 활성화되지 않은 것으로 감지되었습니다. 정상적인 자금 흐름을 보장하려면 먼저 은행 카드를 추가하십시오.',
      noBindCoinAddress: '계좌에 가상 화폐 계좌가 바인딩되거나 활성화되어 있지 않은 것으로 감지되었습니다. 정상적인 자금 순환을 보장하기 위해 먼저 가상 화폐 계좌 주소를 추가하십시오.',
      tradeConfirm: '주문이 곧 제출됩니다. 주문 정보가 올바른지 확인하고 주문 확인을 클릭하여 제출하세요.',
      SellOutSpotOrder: '포지션 주문이 곧 매도될 예정입니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.',
      buyFinance: '[{coin}]을(를) 구매하려고 합니다. 공유: {amount}을(를) 구매하려고 합니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.',
      receiveOrder: '서약 주문({orderNum})이 곧 상환될 예정입니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.'
    }
  },
  message: {
    binSuccess: '바인딩 성공',
    successOperation: '작업 성공',
    logoutSuccess: '성공적으로 종료했습니다',
    editSuccess: '수정 성공',
    addSuccess: '추가 성공',
    copySuccess: '복사 성공',
    copyFailed: '복사 실패'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '일',
      week_day_1: '일',
      week_day_2: '2',
      week_day_3: '삼',
      week_day_4: '4',
      week_day_5: '오',
      week_day_6: '토요일'
    },
    loading: {
      loading: '로드 중'
    }
  },
  helpItems: {
    title: {
      part1: '자산환산금액이 왜 바뀌나요? ',
      part2: 'OTC 거래 시 펀드 비밀번호를 잊어버린 경우 대처 방법',
      part3: 'OTC 거래가 완료된 후 자금은 어디로 흘러가나요? ',
      part4: '닉네임 수정 횟수를 왜 제한해야 하나요?',
      part5: '이전이란 무엇을 의미하며 왜 이전이 필요한가',
      part6: '사용자 계약의 계정 자산을 어떻게 계산하나요? ',
      part7: '포지션 개설 시 설정된 손절매 및 이익실현 수치는 얼마입니까? 어떻게 설정해야 하나요? ',
      part8: '계약 위험을 줄이는 방법은 무엇입니까? ',
      part9: '계약 체결 수량은 무엇을 의미하나요? ',
      part10: '강제청산 지시사항',
      part11: '계약 거래 규칙은 무엇인가요? ',
      part12: '계약 거래에서 마진이란 무엇인가요? ',
      part13: '지정가 주문과 시장가 주문이 무엇인가요? ',
      part14: '계약 거래의 위험은 무엇을 의미합니까',
      part15: '환전은 왜 필요한가요? ',
      part16: 'OTC 거래가 이체된 후 상대방이 제때에 이체를 받지 못한 이유는 무엇입니까? ',
      part17: 'OTC를 통해 테더(USDT)를 구매하는 방법은 무엇인가요? '
    },
    content: {
      part1: '자산의 전환 계산은 현재 위안화로 보유하고 있는 디지털 통화의 가치이며 디지털 자산의 가격 변동으로 인해 변경됩니다. 귀하의 디지털 자산 금액은 변경되지 않았습니다. ',
      part2: 'OTC 거래 펀드 비밀번호를 잊어버린 경우 "내 설정-펀드 비밀번호 설정 클릭"으로 이동하거나 고객 서비스에 문의하여 재설정하세요.',
      part3: 'OTC 구매 주문이 완료된 후 자금은 자산의 법정화폐 계좌에 입력됩니다. 계약 거래 또는 선물 거래를 위해 OTC 구매 자산을 사용해야 하는 경우 자금 이체 모듈로 이동하여 이체하세요. ',
      part4: '거래 보안상의 이유로 현재 닉네임은 한 번만 수정되도록 제한하고 있습니다. ',
      part5: '귀하의 다양한 계좌 간 자금의 독립성을 보장하고 합리적인 위험 통제를 용이하게 하기 위해 각 주요 거래 모듈의 계좌를 이에 따라 분할합니다. 이체란 다양한 거래 계좌 간 자산의 상호 전환을 의미합니다. ',
      part6: '<p>계약 계좌 자본, 계산 방법은 다음과 같습니다:</p> <p>계약 계좌 자본 = 포지션 증거금 + 포지션 변동 손익 + 당좌 계정 사용 가능 금액</p>',
      part7: '이익실현과 손절매는 귀하가 설정한 이익 상한선과 손실한도입니다. 설정된 손절매 금액에 도달하면 시스템이 자동으로 포지션을 청산합니다. 계약 매수 시 리스크 관리용으로 활용할 수 있으며, 반설정 이익실현 금액은 증가액 x 수량 x 레버리지 배수이므로, 합리적으로 리스크 관리를 위해 실제 자산 상황에 맞춰 손절매 설정을 권장합니다. . ',
      part8: '남은 계좌의 사용 가능한 자산을 자금 이체를 통해 컨트랙트 계좌로 이체하거나, 포지션을 줄여 리스크를 줄일 수 있습니다. ',
      part9: '개시 포지션의 수량은 구매하려는 통화의 수량을 나타냅니다. 예: BTC/USDT 거래 쌍의 시작 페이지에서 "롱 매수"를 선택하고 가격을 1,000 USDT로 입력하고 수량을 10 BTC로 입력합니다. 즉, 단가 1,000에 10 BTC를 구매할 것으로 예상됩니다. USDT. ',
      part10: '<p>리스크는 자산의 리스크를 측정하는 지표입니다. 리스크가 100%가 되면 포지션이 청산된 것으로 간주됩니다. 리스크 = (포지션 증거금/계약 계좌 자본)*100%. 사용자가 포지션을 잃지 않도록 시스템은 리스크 조정 비율을 설정하며, 리스크가 시스템에서 설정한 리스크 값에 도달하면 시스템은 강제로 포지션을 청산합니다. 예를 들어, 시스템에서 설정한 조정 비율이 10%인 경우 위험 수준이 90% 이상이면 시스템에 의해 모든 포지션이 강제 폐쇄됩니다. </p> <p>참고: 과도한 리스크로 인해 시스템이 청산을 강제하는 경우 모든 포지션이 청산되므로 불필요한 손실을 피하기 위해 리스크를 합리적으로 관리하시기 바랍니다.</p>',
      part11: '<p> 거래 유형</p> <p>거래 유형은 두 가지 방향으로 나뉩니다: 롱 포지션 개설(매수) 및 숏 포지션 개설(매도):</p> <p>매수 및 이동 매수(강세)는 현재 지수가 상승할 가능성이 있다고 생각하고 설정한 가격이나 현재 시장 가격으로 특정 수의 신규 계약을 매수하기를 희망한다는 의미입니다. </p> <p>공매도(약세)는 현재 지수가 하락할 수 있다고 믿고 자신이 설정한 가격이나 현재 시장 가격으로 특정 수의 신규 계약을 매도하기를 희망한다는 의미입니다. </p> <p>주문 방법</p> <p>지정가 주문: 주문 가격과 수량을 직접 지정해야 합니다.</p> <p>시장가 주문: 지정가 주문만 설정하면 됩니다. 주문 수량, 가격은 현재 시장 가격입니다</p> <p>포지션</p> <p>제출한 개시 주문이 완료되면 이를 포지션이라고 합니다</p> <p>계약 납품 문제</p> <p>플랫폼 계약은 배송 시간이 정해져 있지 않은 무기한 계약입니다. 시스템 청산 조건이 충족되지 않거나 수동으로 포지션을 청산하지 않는 한 포지션을 영구적으로 유지할 수 있습니다. </p> <p>시스템이 포지션을 청산합니다.</p> <p>1: 이익 정지 및 손실 정지 설정에 도달하면 시스템이 자동으로 포지션을 청산합니다.</p> <p>2: 리스크가 너무 높으면 시스템이 강제로 포지션을 청산합니다 </p>',
      part12: '<p>계약 거래에서 사용자는 계약 가격과 수량, 그리고 해당 레버리지 배수에 따라 계약 이행에 대한 재정적 보증으로 자금을 지불함으로써 계약 구매 및 판매에 참여할 수 있습니다. 자금의 종류는 계약금입니다. 사용자가 포지션을 개설하면 증거금이 점유되며, 개설 증거금이 많을수록 계정 위험이 높아집니다. </p> <p>마진 = (시가 * 수량) / 레버리지 배수</p>',
      part13: '지정가 주문은 플랫폼에 위탁하여 거래할 것으로 예상되는 가격을 의미하며, 시장가 주문은 플랫폼에 현재 가격으로 직접 거래하도록 위탁하는 것을 의미합니다. 포지션 개설 규칙에 따르면 시장가 주문이 지정가 주문보다 우선합니다. 지정가 주문을 선택하는 경우, 불합리한 개시 가격으로 인한 손실을 피하기 위해 현재 통화 시장 가격을 기준으로 합리적으로 포지션을 개시하시기 바랍니다. ',
      part14: '위험도는 계약 계정의 위험 지표입니다. 위험도가 100%에 해당하면 청산으로 간주됩니다. 위험이 50%를 초과하는 경우 청산으로 인한 손실을 피하기 위해 포지션을 개설할 때 주의해야 합니다. 계약 자산에 사용 가능한 자금을 보충하거나 포지션을 줄여 위험을 줄일 수 있습니다. ',
      part15: '교환의 기능은 귀하의 자산에 있는 다양한 통화의 자금이 원활하게 유통되도록 하는 것입니다. 선물 계좌에서 획득한 QCC는 자유롭게 USDT로 전환하여 거래할 수 있습니다. 다른 계좌의 USDT도 자유롭게 QCC로 전환하여 거래할 수 있습니다. ',
      part16: '먼저 송금 시 입력하는 결제 수단이 주문 세부정보 페이지에 표시된 내용과 정확히 일치하는지 확인하세요. 그런 다음 결제 수단이 즉시 결제인지 지연 결제인지 확인하세요. 마지막으로, 시스템 점검이나 기타 사유가 있는지 해당 은행 및 결제 기관에 문의하시기 바랍니다. ',
      part17: '<p>방법 1: OTC 구매 및 판매 목록을 통해 구매 및 판매하려는 주문을 선택하세요. </p> <p>방법 2: 게시 버튼을 클릭하여 빠른 거래를 위해 필요에 따라 매수 또는 매도 주문을 게시하세요. 시스템은 귀하를 구매 및 판매 사용자와 신속하게 연결해 드립니다. </p> <p>참고: 구매 주문이 15분 후에도 결제되지 않으면 시스템이 자동으로 주문을 취소하므로 기한 내에 결제해 주시기 바랍니다. 당일 3회 이상 주문 취소 시 당일에는 다시 거래가 불가능하며, 다음날 거래 허가가 복원됩니다. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/kr.js